<template>
  <main>
    <slot></slot>
  </main>
</template>
<script>
export default {
  name: "Page"
};
</script>
<style scoped>
main {
  padding: var(--space-5);
  max-width: var(--page-max-width);
  margin: 0 auto;
  min-height: 100vh;
}
</style>
